<template>
  <div class="p-index"></div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {},
  mounted() {}
};
</script>
